import styled from 'styled-components';
import { Clickable } from 'src/components/clickable';

export const TextLink = styled(Clickable)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
